// EmailJS Configuration
// You need to set up these values in your EmailJS account

export const EMAILJS_CONFIG = {
  // Your EmailJS Service ID (create at https://www.emailjs.com/)
  SERVICE_ID: 'service_stembears',
  
  // Your EmailJS Template ID (create a template in your EmailJS dashboard)
  TEMPLATE_ID: 'template_contact',
  
  // Your EmailJS Public Key (found in your EmailJS account settings)
  PUBLIC_KEY: 'YOUR_PUBLIC_KEY_HERE', // Replace with your actual public key
  
  // Email address where contact form submissions will be sent
  TO_EMAIL: 'admin@stembears.com'
}

// EmailJS Template Variables
// These should match the variables in your EmailJS template
export const EMAILJS_TEMPLATE_PARAMS = {
  from_name: '{{from_name}}',
  from_email: '{{from_email}}',
  subject: '{{subject}}',
  message: '{{message}}',
  inquiry_type: '{{inquiry_type}}',
  to_email: '{{to_email}}'
}
